import type { ProductSendInput, SourceReference, StreamOptions } from '../../application/chat/contracts';
import type { SendInput } from 'flare-chat-core/contracts';
const SEND_FIELDS = new Set(['content', 'suppressUserEcho', 'preserveInputOnError', 'replaceAssistantMessageId']);
const PROTOCOL_FIELDS = new Set([
  'command', 'payloadExtra', 'attachments', 'context_refs', 'knowledge_refs',
  'modeKey', 'manualModeKey', 'actionKey', 'targetMode', 'executionProfile',
  'modePreference', 'runtimePreferences', 'runId', 'runEventAfterSequence',
]);
const references = (items: SourceReference[] = []) => [...new Set(items.map((item) => typeof item === 'string' ? item : item.source_id).filter(Boolean))]
  .map((source_id) => ({ source_id }));

const referenceInputs = (options: ProductSendInput, stream: StreamOptions) => ({
  context_refs: references(options.context_refs ?? stream.context_refs ?? []),
  knowledge_refs: references(options.knowledge_refs ?? stream.knowledge_refs ?? []),
});

/** Transitional official-view input mapping; no wire fields reach public send. */
export const buildHostSendInput = (options: ProductSendInput = {}): SendInput => {
  const stream = options.streamOptions ?? {};
  if (Object.keys(stream).some((key) => !PROTOCOL_FIELDS.has(key))) throw new TypeError('Unsupported official stream option');
  const { command, payloadExtra = {} } = stream;
  const fields = Object.fromEntries(Object.entries(stream).filter(([key]) => !['command', 'payloadExtra', 'attachments', 'context_refs', 'knowledge_refs'].includes(key)));
  const operationKey = command || payloadExtra.command || 'send_message';
  if (typeof operationKey !== 'string') throw new TypeError('Operation key must be text');
  const generic = Object.fromEntries(Object.entries(options).filter(([key, value]) => SEND_FIELDS.has(key) && value !== undefined));
  const snapshot = options.attachedSessionFilesSnapshot;
  return {
    ...generic,
    operation: { operationKey, input: { ...fields, parameters: payloadExtra } },
    ...referenceInputs(options, stream),
    ...(snapshot ? { attachedSessionFilesSnapshot: snapshot.map(({ uid }) => ({ uid })) } : {}),
  };
};
